import React, { useEffect, useState } from 'react';
import { LayoutPageHeading, LayoutPage } from 'src/modules/layout';
import { ProductsCategoriesStore } from '../../store/types';
import { ProductsCategoriesOverview } from 'src/modules/products';
import { useIntl } from 'react-intl';

const ProductsCategoriesPage: React.FunctionComponent<ProductsCategoriesStore> = (props) => {
  const intl = useIntl();
  // Workaround to force redraw since on SSG the content language or outputChannel doesn't update
  const [mountReRenderKey, setMountReRenderKey] = useState('products-categories-not-mounted');
  useEffect(() => setMountReRenderKey('products-categories-mounted'), []);

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/products/head/page_title' }),
    description: intl.formatMessage({ id: 'page/products/head/meta_description' }),
    breadcrumbs: [
      {
        title: intl.formatMessage({ id: 'breadcrumbs/products' }),
        href: '/products',
        as: '/products',
      },
    ],
  };

  const { productCategories } = props;
  return (
    <LayoutPage {...pageProperties} key={mountReRenderKey}>
      <LayoutPageHeading
        titleKey="page/products/categories/title"
        sublineKey="page/products/categories/subline"
      />

      <ProductsCategoriesOverview productCategories={productCategories} bordered={false} />
    </LayoutPage>
  );
};

export default ProductsCategoriesPage;
